import Blue from "~/core";

new Blue({
	name: 'Reset Password Checker',
	selector: "form[action='/passwordreset']",
	setup(form) {
    // First Password Field
    const indicator = document.createElement('div');
    const wrapper = form.querySelector('.password-strength');
    const input = wrapper.querySelector('#Password');
		const explanation = wrapper.querySelector('.text-danger');

    // Second (Confirm) Password Field
    const inputConfirm = form.querySelector('#PasswordConfirm');
    const explanationConfirm = inputConfirm.parentElement.querySelector('.text-danger');

    // Set up
    indicator.classList.add('password-strength-indicator-bar');
    input.insertAdjacentElement('afterend', indicator);
    this.$verify(indicator, explanation, "");

    // Events
		this.$addEvents(input, "input", e => {
			let val = e.target.value;
			this.$verify(indicator, explanation, val);
			checkPasswordMatch();
		});

    this.$addEvents(inputConfirm, "input", e => {
			checkPasswordMatch();
		});

    // Functions
    function checkPasswordMatch() {
      if (!inputConfirm.value) return;

			if (input.value !== inputConfirm.value)
        explanationConfirm.textContent = "Passwords do not match.";
      else 
        explanationConfirm.textContent = "";
    }
	}
});